import { publicHost } from "../../lib/public-url";

/**
 * The customer-facing join link for a desk: the journey host's ROOT, with the
 * queue in the query string.
 *
 * `?queue=` must carry the queue's **id**, never its join code. The journey
 * matches `q.id === queueId` (`WalkInJourney.tsx`), and `WalkInQueueRead`
 * exposes only `id`. A join code here is not rejected — it fails the match and
 * the visitor is asked to pick a desk, so the link degrades SILENTLY. That is
 * why this composer takes an id and nothing else: there is no call site left
 * that can pass the wrong token.
 *
 * Single composer on purpose (2026-09-17). The Queues list's "Copy join link"
 * and the designer's Publish-step link + QR are required to be ONE link; two
 * call sites composing the same shape by hand is how they drift.
 *
 * `publicHost("join")` is SERVED, never composed, so an empty host means the
 * tenant has no resolved join surface. Empty string then, never a dead
 * `https:///?queue=…` — the callers say so in their own words.
 *
 * Path shape, for the record: the worker-rendered pages at `/queues`,
 * `/queues/<id>/join`, `/<id>` and `/<id>/join` are being removed from every
 * public host, and the journey owns every path on the host afterwards. A bare
 * path segment carrying the join code resolves to the journey's not-found.
 */
export const queueJoinUrl = (queueId: string | null | undefined): string => {
  const host = publicHost("join");
  const id = (queueId ?? "").trim();
  if (!host || !id) return "";
  return `https://${host}/?queue=${encodeURIComponent(id)}`;
};
